import MappingEdit from './MappingEdit';
import MappingsList from './MappingsList';

const resource = {
  list: MappingsList,
  // edit: MappingEdit,
};

export default resource;
